import { get, post } from './request'

export let all = (success, failure) => {
  return get(
    `api/cms/features`, success, failure
  )
}

export let save = (feature, success, failure) => post(
  `api/cms/features/${feature.id}/update`, feature, success, failure
)


